/**
 * Infer a space type for a room that already has real desks and job
 * assignments but was never given a purpose — 99 such rooms exist live. Only
 * two buckets are confident enough to suggest: a single desk reads as a
 * private office, and four or more reads as open plan. Two or three desks is
 * genuinely ambiguous (a shared office? an unusually small open area?) so it
 * is deliberately left unguessed rather than forcing a coin flip onto data
 * nobody reviewed.
 *
 * This only ever proposes a code — the caller marks the room "Custom" and
 * requires an explicit accept, never a silent bulk write.
 *
 * @param {number} seatCount sum of `table.capacity` for the room's real tables
 * @returns {"PRIVATE_OFFICE"|"OPEN_PLAN"|null}
 */
export function inferSpaceTypeCodeFromSeatCount(seatCount) {
  if (seatCount === 1) return "PRIVATE_OFFICE";
  if (seatCount >= 4) return "OPEN_PLAN";
  return null;
}
